{
  "labels": {
    "paste": "粘贴",
    "pasteAsPlaintext": "粘贴为纯文本",
    "pasteCharts": "粘贴图表",
    "selectAll": "全部选中",
    "multiSelect": "添加元素到选区",
    "moveCanvas": "移动画布",
    "cut": "剪切",
    "copy": "拷贝",
    "copyAsPng": "复制为 PNG 到剪贴板",
    "copyAsSvg": "复制为 SVG 到剪贴板",
    "copyText": "复制文本到剪贴板",
    "copySource": "复制源码到剪贴板",
    "convertToCode": "转换成代码",
    "bringForward": "上移一层",
    "sendToBack": "置于底层",
    "bringToFront": "置于顶层",
    "sendBackward": "下移一层",
    "delete": "删除",
    "copyStyles": "拷贝样式",
    "pasteStyles": "粘贴样式",
    "stroke": "描边",
    "changeStroke": "更改描边颜色",
    "background": "背景",
    "changeBackground": "更改背景颜色",
    "fill": "填充",
    "strokeWidth": "描边宽度",
    "strokeStyle": "边框样式",
    "strokeStyle_solid": "实线",
    "strokeStyle_dashed": "虚线",
    "strokeStyle_dotted": "点虚线",
    "sloppiness": "线条风格",
    "opacity": "透明度",
    "textAlign": "文本对齐",
    "edges": "边角",
    "sharp": "尖锐",
    "round": "圆润",
    "arrowheads": "端点",
    "arrowhead_none": "无",
    "arrowhead_arrow": "箭头",
    "arrowhead_bar": "条状",
    "arrowhead_circle": "圆点",
    "arrowhead_circle_outline": "圆点（空心）",
    "arrowhead_triangle": "三角箭头",
    "arrowhead_triangle_outline": "三角箭头（空心）",
    "arrowhead_diamond": "菱形",
    "arrowhead_diamond_outline": "菱形（空心）",
    "arrowhead_crowfoot_many": "鸦爪标记（多）",
    "arrowhead_crowfoot_one": "鸦爪标记（一）",
    "arrowhead_crowfoot_one_or_many": "鸦爪标记（一或多）",
    "more_options": "更多选项",
    "arrowtypes": "箭头类型",
    "arrowtype_sharp": "直箭头",
    "arrowtype_round": "曲线箭头",
    "arrowtype_elbowed": "拐角箭头",
    "fontSize": "字体大小",
    "fontFamily": "字体",
    "addWatermark": "添加 “使用 Excalidraw 创建” 水印",
    "handDrawn": "手写",
    "normal": "普通",
    "code": "代码",
    "small": "小",
    "medium": "中",
    "large": "大",
    "veryLarge": "加大",
    "solid": "实心",
    "hachure": "线条",
    "zigzag": "之字形折线",
    "crossHatch": "交叉线条",
    "thin": "细",
    "bold": "粗",
    "left": "左对齐",
    "center": "居中",
    "right": "右对齐",
    "extraBold": "特粗",
    "architect": "朴素",
    "artist": "艺术",
    "cartoonist": "漫画家",
    "fileTitle": "文件名",
    "colorPicker": "取色器",
    "canvasColors": "画布上的",
    "canvasBackground": "画布背景",
    "drawingCanvas": "绘制 Canvas",
    "clearCanvas": "清除画布",
    "layers": "图层",
    "actions": "操作",
    "language": "语言",
    "liveCollaboration": "实时协作...",
    "duplicateSelection": "复制",
    "untitled": "无标题",
    "name": "名字",
    "yourName": "您的姓名",
    "madeWithExcalidraw": "使用 Excalidraw 创建",
    "group": "编组",
    "ungroup": "解除编组",
    "collaborators": "协作者",
    "toggleGrid": "切换网格显示",
    "addToLibrary": "添加到素材库中",
    "removeFromLibrary": "从素材库中移除",
    "libraryLoadingMessage": "正在加载素材库…",
    "libraries": "浏览素材库",
    "loadingScene": "正在加载绘图…",
    "loadScene": "从文件加载绘图",
    "align": "对齐",
    "alignTop": "顶部对齐",
    "alignBottom": "底端对齐",
    "alignLeft": "左对齐",
    "alignRight": "右对齐",
    "centerVertically": "垂直居中",
    "centerHorizontally": "水平居中",
    "distributeHorizontally": "水平等距分布",
    "distributeVertically": "垂直等距分布",
    "flipHorizontal": "水平翻转",
    "flipVertical": "垂直翻转",
    "viewMode": "查看模式",
    "share": "分享",
    "showStroke": "显示描边颜色选择器",
    "showBackground": "显示背景颜色选择器",
    "showFonts": "显示字体选择器",
    "toggleTheme": "切换浅色/深色主题",
    "theme": "主题",
    "personalLib": "个人素材库",
    "excalidrawLib": "Excalidraw 素材库",
    "decreaseFontSize": "缩小字体大小",
    "increaseFontSize": "放大字体大小",
    "unbindText": "取消文本绑定",
    "bindText": "将文本绑定到容器",
    "createContainerFromText": "将文本包围在容器中",
    "link": {
      "edit": "编辑链接",
      "editEmbed": "编辑嵌入链接",
      "create": "添加链接",
      "label": "链接",
      "labelEmbed": "链接与嵌入",
      "empty": "未设定链接",
      "hint": "在此处输入或粘贴您的链接",
      "goToElement": "前往目标元素"
    },
    "lineEditor": {
      "edit": "编辑线条",
      "editArrow": "编辑箭头"
    },
    "polygon": {
      "breakPolygon": "解除多边形",
      "convertToPolygon": "转换为多边形"
    },
    "elementLock": {
      "lock": "锁定",
      "unlock": "解除锁定",
      "lockAll": "全部锁定",
      "unlockAll": "全部解锁"
    },
    "statusPublished": "已发布",
    "sidebarLock": "侧边栏常驻",
    "selectAllElementsInFrame": "选择画框中的所有元素",
    "removeAllElementsFromFrame": "分离出画框中的所有元素",
    "eyeDropper": "从画布上取色",
    "textToDiagram": "文字至图表",
    "prompt": "Prompt",
    "followUs": "关注我们",
    "discordChat": "Discord 群组",
    "zoomToFitViewport": "缩放以适应视图",
    "zoomToFitSelection": "缩放以适应选区",
    "zoomToFit": "缩放以适应所有元素",
    "installPWA": "在本地安装 Excalidraw (PWA)",
    "autoResize": "启用文本自动缩放",
    "imageCropping": "图片裁剪",
    "unCroppedDimension": "未裁剪的尺寸",
    "copyElementLink": "复制此对象的链接",
    "linkToElement": "链接到对象",
    "wrapSelectionInFrame": "用选中的元素创建画框",
    "tab": "Tab",
    "shapeSwitch": "切换形状"
  },
  "elementLink": {
    "title": "链接到对象",
    "desc": "点击画布上的形状或粘贴链接。",
    "notFound": "在画布上找不到链接的对象。"
  },
  "library": {
    "noItems": "尚未添加任何项目……",
    "hint_emptyLibrary": "选中画布上的项目添加到此处，或从下方的公共素材库中导入。",
    "hint_emptyPrivateLibrary": "选中画布上的项目添加到此处。",
    "search": {
      "inputPlaceholder": "搜索库",
      "heading": "匹配的库",
      "noResults": "无匹配项……",
      "clearSearch": "清除搜索"
    }
  },
  "search": {
    "title": "在画布上查找",
    "noMatch": "无匹配项…",
    "singleResult": "结果",
    "multipleResults": "结果",
    "placeholder": "在画布上查找文本…",
    "frames": "画框",
    "texts": "文本"
  },
  "buttons": {
    "clearReset": "重置画布",
    "exportJSON": "导出为文件",
    "exportImage": "导出图片...",
    "export": "保存到...",
    "copyToClipboard": "复制到剪贴板",
    "copyLink": "复制链接",
    "save": "保存至当前文件",
    "saveAs": "保存为",
    "load": "打开",
    "getShareableLink": "获取共享链接",
    "close": "关闭",
    "selectLanguage": "选择语言",
    "scrollBackToContent": "滚动回到内容",
    "zoomIn": "放大",
    "zoomOut": "缩小",
    "resetZoom": "重置缩放",
    "menu": "菜单",
    "done": "完成",
    "edit": "编辑",
    "undo": "撤销",
    "redo": "重做",
    "resetLibrary": "重置素材库",
    "createNewRoom": "新建会议室",
    "fullScreen": "全屏",
    "darkMode": "深色模式",
    "lightMode": "浅色模式",
    "systemMode": "系统模式",
    "zenMode": "禅模式",
    "objectsSnapMode": "吸附至对象",
    "exitZenMode": "退出禅模式",
    "cancel": "取消",
    "saveLibNames": "保存名称并退出",
    "clear": "清除",
    "remove": "删除",
    "embed": "切换嵌入",
    "publishLibrary": "重命名或发布",
    "submit": "提交",
    "confirm": "确定",
    "embeddableInteractionButton": "点击以开始交互"
  },
  "alerts": {
    "clearReset": "这将会清除整个画布。您是否要继续?",
    "couldNotCreateShareableLink": "无法创建共享链接",
    "couldNotCreateShareableLinkTooBig": "无法创建可共享链接：画布过大",
    "couldNotLoadInvalidFile": "无法加载无效的文件",
    "importBackendFailed": "从后端导入失败。",
    "cannotExportEmptyCanvas": "无法导出空白画布。",
    "couldNotCopyToClipboard": "无法复制到剪贴板。",
    "decryptFailed": "无法解密数据。",
    "uploadedSecurly": "上传已被端到端加密保护，这意味着 Excalidraw 的服务器和第三方都无法读取内容。",
    "loadSceneOverridePrompt": "加载外部绘图将取代您现有的内容。您想要继续吗？",
    "collabStopOverridePrompt": "停止会话将覆盖您先前本地存储的绘图。 您确定吗？\n\n(如果您想保持本地绘图，只需关闭浏览器选项卡。)",
    "errorAddingToLibrary": "无法将项目添加到素材库中",
    "errorRemovingFromLibrary": "无法从素材库中移除项目",
    "confirmAddLibrary": "这将添加 {{numShapes}} 个形状到您的素材库中。您确定吗？",
    "imageDoesNotContainScene": "此图像似乎不包含任何画布数据。您是否在导出时启用了画布嵌入功能？",
    "cannotRestoreFromImage": "无法从此图像文件恢复画布",
    "invalidSceneUrl": "无法从提供的 URL 导入场景。它或者格式不正确，或者不包含有效的 Excalidraw JSON 数据。",
    "resetLibrary": "这将会清除你的素材库。你确定要这么做吗？",
    "removeItemsFromsLibrary": "确定要从素材库中删除 {{count}} 个项目吗？",
    "invalidEncryptionKey": "密钥必须包含22个字符。实时协作已被禁用。",
    "collabOfflineWarning": "无网络连接。\n您的改动将不会被保存！",
    "localStorageQuotaExceeded": "超过浏览器存储配额。更改将不会被保存。"
  },
  "errors": {
    "unsupportedFileType": "不支持的文件格式。",
    "imageInsertError": "无法插入图像。请稍后再试……",
    "fileTooBig": "文件过大。最大允许的大小为 {{maxSize}}。",
    "svgImageInsertError": "无法插入 SVG 图像。该 SVG 标记似乎是无效的。",
    "failedToFetchImage": "无法获取图片。",
    "cannotResolveCollabServer": "无法连接到实时协作服务器。请重新加载页面并重试。",
    "importLibraryError": "无法加载素材库",
    "saveLibraryError": "无法将库保存至存储。请将库保存为本地文件，以确保您的更改不被丢失。",
    "collabSaveFailed": "无法保存到后端数据库。如果问题持续存在，您应该保存文件到本地，以确保您的工作不会丢失。",
    "collabSaveFailed_sizeExceeded": "无法保存到后端数据库，画布似乎过大。您应该保存文件到本地，以确保您的工作不会丢失。",
    "imageToolNotSupported": "图片已被禁用。",
    "brave_measure_text_error": {
      "line1": "您似乎正在使用 Brave 浏览器并启用了<bold>积极阻止指纹识别</bold>的设置。",
      "line2": "这可能会破坏绘图中的 <bold>文本元素</bold>。",
      "line3": "我们强烈建议禁用此设置。您可以按照<link>这些步骤</link>来设置。",
      "line4": "如果禁用此设置无法修复文本元素的显示，请在 GitHub 上提交一个 <issueLink>issue</issueLink> ，或者在 <discordLink>Discord</discordLink> 上反馈"
    },
    "libraryElementTypeError": {
      "embeddable": "嵌入元素不能添加到素材库。",
      "iframe": "不能将 IFrame 元素添加到素材库中。",
      "image": "我们不久将支持添加图片到素材库"
    },
    "asyncPasteFailedOnRead": "无法粘贴（无法读取系统剪贴板）。",
    "asyncPasteFailedOnParse": "无法粘贴。",
    "copyToSystemClipboardFailed": "无法复制到剪贴板。"
  },
  "toolBar": {
    "selection": "选择",
    "lasso": "套索选择",
    "image": "插入图像",
    "rectangle": "矩形",
    "diamond": "菱形",
    "ellipse": "椭圆",
    "arrow": "箭头",
    "line": "线条",
    "freedraw": "自由书写",
    "text": "文字",
    "library": "素材库",
    "lock": "绘制后保持所选的工具栏状态",
    "penMode": "笔模式 – 避免误触",
    "link": "为选定的形状添加或更改链接",
    "eraser": "橡皮",
    "frame": "画框工具",
    "magicframe": "线框图至代码",
    "embeddable": "嵌入网页",
    "laser": "激光笔",
    "hand": "抓手（平移工具）",
    "extraTools": "更多工具",
    "mermaidToExcalidraw": "Mermaid 至 Excalidraw",
    "convertElementType": "切换形状种类"
  },
  "element": {
    "rectangle": "矩形",
    "diamond": "菱形",
    "ellipse": "椭圆",
    "arrow": "箭头",
    "line": "线条",
    "freedraw": "自由书写",
    "text": "文字",
    "image": "图片",
    "group": "组",
    "frame": "画框",
    "magicframe": "线框图至代码",
    "embeddable": "嵌入网页",
    "selection": "选择",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "画布动作",
    "selectedShapeActions": "选定形状操作",
    "shapes": "形状"
  },
  "hints": {
    "dismissSearch": "按{{shortcut}}取消搜索",
    "canvasPanning": "要移动画布，请按住{{shortcut_1}}或{{shortcut_2}}同时拖拽鼠标，或使用抓手工具。",
    "linearElement": "点击创建多个点 拖动创建直线",
    "arrowTool": "点击创建多个点，拖动创建直线。按 {{shortcut}} 切换箭头类型。",
    "arrowBindModifiers": "",
    "freeDraw": "点击并拖动，完成时松开",
    "text": "提示：您也可以使用选择工具双击任意位置来添加文字",
    "embeddable": "点击并拖动以创建嵌入网页",
    "text_selected": "双击或按{{shortcut}}编辑文本",
    "text_editing": "按{{shortcut_1}}或{{shortcut_2}}完成编辑",
    "linearElementMulti": "点击最后的点或按{{shortcut_1}}或{{shortcut_2}}完成",
    "lockAngle": "可以按住{{shortcut}}来约束角度",
    "resize": "缩放时按住{{shortcut_1}}可以约束宽高比例，\n按住{{shortcut_2}}可以从中间缩放",
    "resizeImage": "按住{{shortcut_1}}可以自由缩放，\n按住{{shortcut_2}}可以从中间缩放",
    "rotate": "旋转时可以按住{{shortcut}}来约束角度",
    "lineEditor_info": "按住{{shortcut_1}}双击，或者按{{shortcut_2}}编辑点",
    "lineEditor_line_info": "双击或按{{shortcut}}编辑点",
    "lineEditor_pointSelected": "按{{shortcut_1}}移除点，按{{shortcut_2}}复制点，拖拽移动点",
    "lineEditor_nothingSelected": "选择要编辑的点 (按住{{shortcut_1}}选择多个)，\n或按住{{shortcut_2}}并点击以添加新点",
    "publishLibrary": "发布您自己的素材库",
    "bindTextToElement": "按{{shortcut}}添加文本",
    "createFlowchart": "按{{shortcut}}创建流程图",
    "deepBoxSelect": "按住{{shortcut}}深度选择，并避免拖拽",
    "eraserRevert": "按住{{shortcut}}反选被标记删除的元素",
    "firefox_clipboard_write": "将高级配置首选项“dom.events.asyncClipboard.clipboardItem”设置为“true”可以启用此功能。要更改 Firefox 的高级配置首选项，请前往“about:config”页面。",
    "disableSnapping": "按住{{shortcut}}禁用吸附",
    "enterCropEditor": "双击图片或按{{shortcut}}开始裁剪",
    "leaveCropEditor": "点击图片以外的区域或按{{shortcut_1}}或{{shortcut_2}}完成裁剪"
  },
  "canvasError": {
    "cannotShowPreview": "无法显示预览",
    "canvasTooBig": "画布可能过大。",
    "canvasTooBigTip": "提示：尝试将最远的元素移动到和其它元素更近一些。"
  },
  "errorSplash": {
    "headingMain": "遇到异常。请尝试<button>重新加载页面</button>。",
    "clearCanvasMessage": "如果重新加载页面无效，请尝试<button>清除画布</button>。",
    "clearCanvasCaveat": "这会造成当前工作丢失",
    "trackedToSentry": "标识符为{{eventId}}的错误已在我们的系统中被记录",
    "openIssueMessage": "我们非常谨慎地处理错误信息，您的画布内容不会被包含在错误报告中。如果您的画布内容不需要保持私密，请考虑在我们的 <button>bug 跟踪系统</button>上提供更多信息。请复制粘贴以下信息到 GitHub Issue 中。",
    "sceneContent": "画布内容:"
  },
  "shareDialog": {
    "or": "或"
  },
  "roomDialog": {
    "desc_intro": "邀请他人协作绘图。",
    "desc_privacy": "别担心，会话是端到端加密、完全私密的。即使是我们的服务器也无法看到您绘制的内容。",
    "button_startSession": "开始会话",
    "button_stopSession": "结束会话",
    "desc_inProgressIntro": "实时协作会话进行中。",
    "desc_shareLink": "分享此链接给你要协作的用户",
    "desc_exitSession": "停止会话将中断您与房间的连接，但您依然可以在本地继续使用画布。请注意，这不会影响到其他用户，他们仍可以在他们的版本上继续协作。",
    "shareTitle": "加入 Excalidraw 实时协作会话"
  },
  "errorDialog": {
    "title": "错误"
  },
  "exportDialog": {
    "disk_title": "保存到本地",
    "disk_details": "将画布数据导出为文件，以便以后导入",
    "disk_button": "保存为文件",
    "link_title": "分享链接",
    "link_details": "导出为只读链接。",
    "link_button": "导出链接",
    "excalidrawplus_description": "将画布保存到您的 Excalidraw+ 工作区。",
    "excalidrawplus_button": "导出",
    "excalidrawplus_exportError": "暂时无法导出到 Excalidraw+ ..."
  },
  "helpDialog": {
    "blog": "浏览我们的博客",
    "click": "单击",
    "deepSelect": "深度选择",
    "deepBoxSelect": "在方框内深度选择并避免拖拽",
    "createFlowchart": "从一个基本元素创建流程图",
    "navigateFlowchart": "在流程图元素间移动",
    "curvedArrow": "曲线箭头",
    "curvedLine": "曲线",
    "documentation": "文档",
    "doubleClick": "双击",
    "drag": "拖动",
    "editor": "编辑器",
    "editLineArrowPoints": "编辑线条或箭头的点",
    "editText": "添加或编辑文本",
    "github": "提交问题",
    "howto": "帮助文档",
    "or": "或",
    "preventBinding": "禁用箭头吸附",
    "tools": "工具",
    "shortcuts": "快捷键列表",
    "textFinish": "完成编辑 (文本编辑器)",
    "textNewLine": "添加新行(文本编辑器)",
    "title": "帮助",
    "view": "视图",
    "zoomToFit": "缩放以适应所有元素",
    "zoomToSelection": "缩放到选区",
    "toggleElementLock": "锁定/解锁",
    "movePageUpDown": "上下移动页面",
    "movePageLeftRight": "左右移动页面",
    "cropStart": "裁剪图片",
    "cropFinish": "完成图片裁剪"
  },
  "clearCanvasDialog": {
    "title": "清除画布"
  },
  "publishDialog": {
    "title": "发布素材库",
    "itemName": "项目名称",
    "authorName": "作者名",
    "githubUsername": "GitHub 用户名",
    "twitterUsername": "Twitter 用户名",
    "libraryName": "名称",
    "libraryDesc": "简介",
    "website": "网址",
    "placeholder": {
      "authorName": "您的名字或用户名",
      "libraryName": "素材库名称",
      "libraryDesc": "介绍您的素材库，让人们了解其用途",
      "githubHandle": "GitHub 用户名（可选），填写后，您可以编辑已提交待审的素材库",
      "twitterHandle": "Twitter 用户名（可选），填写后，当我们在Twitter发布推广信息时便可提及您",
      "website": "您个人网站的或任意的链接（可选）"
    },
    "errors": {
      "required": "必填",
      "website": "输入一个有效的URL"
    },
    "noteDescription": "提交后，您的素材库将被包含在<link>公共素材库广场</link>以供其他人在绘图中使用。",
    "noteGuidelines": "提交的素材库需先经人工审核。在提交之前，请先阅读<link>指南</link> 。后续沟通和对库的修改需要 GitHub 账号，但这不是必须的。",
    "noteLicense": "提交即表明您已同意素材库将遵循 <link>MIT 许可证</link>，简而言之，任何人都可以不受限制地使用它们。",
    "noteItems": "素材库中每个项目都有各自的名称以供筛选。以下项目将被包含：",
    "atleastOneLibItem": "请选择至少一个素材库以开始",
    "republishWarning": "注意：部分选中的项目已经发布或提交。请仅在更新已有或已提交的素材库时重复提交项目。"
  },
  "publishSuccessDialog": {
    "title": "素材库已提交",
    "content": "谢谢你 {{authorName}}。您的素材库已被提交审核。请点击<link>此处</link>跟进此次提交的状态"
  },
  "confirmDialog": {
    "resetLibrary": "重置素材库",
    "removeItemsFromLib": "从素材库中删除选中的项目"
  },
  "imageExportDialog": {
    "header": "导出图片",
    "label": {
      "withBackground": "背景",
      "onlySelected": "仅选中",
      "darkMode": "深色模式",
      "embedScene": "包含画布数据",
      "scale": "缩放比例",
      "padding": "内边距"
    },
    "tooltip": {
      "embedScene": "画布数据将被保存到导出的 PNG/SVG 文件，以便恢复。\n将会增加导出文件的大小。"
    },
    "title": {
      "exportToPng": "导出为 PNG",
      "exportToSvg": "导出为 SVG",
      "copyPngToClipboard": "复制 PNG 到剪切板"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "复制到剪贴板"
    }
  },
  "encrypted": {
    "tooltip": "您的绘图采用端到端加密，其内容对于 Excalidraw 服务器是不可见的。",
    "link": "Excalidraw 中关于端到端加密的博客"
  },
  "stats": {
    "angle": "角度",
    "shapes": "形状",
    "height": "高度",
    "scene": "画布",
    "selected": "选中",
    "storage": "存储",
    "fullTitle": "画布与形状属性",
    "title": "属性",
    "generalStats": "概况",
    "elementProperties": "形状属性",
    "total": "总计",
    "version": "版本",
    "versionCopy": "点击复制",
    "versionNotAvailable": "版本不可用",
    "width": "宽度"
  },
  "toast": {
    "addedToLibrary": "添加到素材库中",
    "copyStyles": "样式已拷贝。",
    "copyToClipboard": "已复制到剪切板。",
    "copyToClipboardAsPng": "已将 {{exportSelection}} 作为 PNG 复制到剪贴板\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "已将 {{exportSelection}} 作为 SVG 复制到剪贴板\n({{exportColorScheme}})",
    "fileSaved": "文件已保存。",
    "fileSavedToFilename": "保存到 {filename}",
    "canvas": "画布",
    "selection": "所选项",
    "pasteAsSingleElement": "使用 {{shortcut}} 粘贴为单个元素，\n或粘贴到现有的文本编辑器里",
    "unableToEmbed": "目前不允许嵌入此网址。请在 GitHub 上提 issue 请求将此网址加入白名单",
    "unrecognizedLinkFormat": "您嵌入的链接不符合格式要求。请尝试粘贴源网站提供的“嵌入 (embed)”字符串",
    "elementLinkCopied": "链接已复制到剪贴板"
  },
  "colors": {
    "transparent": "透明",
    "black": "黑",
    "white": "白",
    "red": "红",
    "pink": "粉红",
    "grape": "紫红",
    "violet": "蓝紫",
    "gray": "灰",
    "blue": "蓝",
    "cyan": "青",
    "teal": "蓝绿",
    "green": "绿",
    "yellow": "黄",
    "orange": "橙",
    "bronze": "古铜"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "是否前往 Excalidraw+ ？",
      "menuHint": "导出、首选项、语言……"
    },
    "defaults": {
      "menuHint": "导出、首选项……",
      "center_heading": "图，化繁为简。",
      "toolbarHint": "选择工具并开始绘图！",
      "helpHint": "快捷键和帮助"
    }
  },
  "colorPicker": {
    "color": "颜色",
    "mostUsedCustomColors": "常用自定义颜色",
    "colors": "颜色",
    "shades": "色调明暗",
    "hexCode": "十六进制值",
    "noShades": "此颜色没有可用的明暗变化"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "导出为图片",
        "button": "导出为图片",
        "description": "将画布数据导出为图片，以便以后导入。"
      },
      "saveToDisk": {
        "title": "保存到本地",
        "button": "保存到本地",
        "description": "将画布数据导出为文件，以便以后导入。"
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "导出到 Excalidraw+",
        "description": "将画布保存到您的 Excalidraw+ 工作区。"
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "从文件加载",
        "button": "从文件加载",
        "description": "从文件加载将<bold>替换您现有的内容</bold>。<br></br>您可以先使用下列方式备份您的绘图。"
      },
      "shareableLink": {
        "title": "从链接加载",
        "button": "替换我的内容",
        "description": "加载外部绘图将<bold>替换您现有的内容</bold>。<br></br>您可以先使用下列方式备份您的绘图。"
      }
    }
  },
  "mermaid": {
    "title": "Mermaid 至 Excalidraw",
    "button": "插入",
    "description": "目前仅支持<flowchartLink>流程图</flowchartLink>、<sequenceLink>序列图</sequenceLink>和<classLink>类图</classLink>。其他类型在 Excalidraw 中将以图像呈现。",
    "syntax": "Mermaid 语法",
    "preview": "预览",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": "快速搜索"
  },
  "fontList": {
    "badge": {
      "old": "旧的"
    },
    "sceneFonts": "画布中的",
    "availableFonts": "可用字体",
    "empty": "未找到字体"
  },
  "userList": {
    "empty": "未找到用户",
    "hint": {
      "text": "点击关注用户",
      "followStatus": "您已关注此用户",
      "inCall": "用户在语音通话中",
      "micMuted": "用户的麦克风已静音",
      "isSpeaking": "用户正在说话"
    }
  },
  "commandPalette": {
    "title": "命令面板",
    "shortcuts": {
      "select": "选择",
      "confirm": "确定",
      "close": "关闭"
    },
    "recents": "最近使用",
    "search": {
      "placeholder": "搜索菜单、命令、探索隐藏功能",
      "noMatch": "没有匹配的命令……"
    },
    "itemNotAvailable": "命令不可用……",
    "shortcutHint": "用 {{shortcut}} 打开命令面板"
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Option",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Esc",
    "enter": "回车键",
    "shift": "Shift",
    "spacebar": "空格",
    "delete": "Delete",
    "mmb": "鼠标滚轮"
  }
}
